import React, { useEffect, useRef, useState } from 'react'
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import FactoryIcon from '@mui/icons-material/Factory';
import axios from 'axios';
import { baseUrl, path } from '../../constants';
import Player from '../../HulluWare/Player';
import { Oval } from 'react-loader-spinner';
import CancelIcon from '@mui/icons-material/Cancel';
import {api} from "../../api"

export default function Preview({ courseId, setSelectedCourse, selectedCourse, refetch }) {
    let s = selectedCourse
    const [loaded, setLoaded] = useState(!!s.preview)
    const [queued, setQueued] = useState(s.queued)
    const [progress, setProgress] = useState(0)
    const fileRef = useRef()
    const [source, setSource] = useState({
            url: baseUrl + s.preview,
            label: s.type,
            type: 'application/x-mpegURL',
            previewThumbnail: s.previewThumbnail,
            thumbnail: s.thumbnail,
            values: s.languages
    })
    // const config = {
    //     onUploadProgress: progressEvent => console.log(progressEvent.loaded)
    // }

    useEffect(() => {
        // api(path.getVideoStream + '/' + courseId + '?preview=true').then(response => {
        //     const data = response.data
        //     if(data.success){
        //         if(data.stream?.path){
        //             let s = data.stream
        //             setSource({
        //                 url: baseUrl + s.path,
        //                 label: s.type,
        //                 type: 'application/x-mpegURL',
        //                 previewThumbnail: s.previewThumbnail,
        //                 thumbnail: s.thumbnail
        //             })
        //             setLoaded(true)
        //         } else {
        //             setLoaded(false)
        //         }
        //     }
        // })
    }, [])
    
    const uploadStream = (file) => {
        if(!file) return alert('file must be selected.')
        let form  = new FormData()
        form.append('file', file)
        console.log(file)
        setLoaded(false)
        api(path.uploadStreamFile + '/' + s.id + '?preview=true', {
            data: form,
            method: 'post',
            onUploadProgress: progressEvent => {
                let prog = progressEvent.loaded / progressEvent.total
                console.log(prog)
                setProgress(prog * 100)
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if(response.data.success){
                let c = response.data.course
                // setLoaded(true)
                setProgress(null)
                setQueued(true)
                // setSource({
                //     url: baseUrl + c.preview,
                //     // label: s.type,
                //     type: 'application/x-mpegURL',
                //     previewThumbnail: c.previewThumbnail,
                //     thumbnail: c.thumbnail,
                //     values: c.languages
                // })
                refetch()
            }
        }).catch(e => {
            alert(e)
            setProgress(0)
        })
    }
    
  return (
    <div className='fixed inset-0 bg-[#00000070] flex items-center justify-center z-[999999] max-md:p-4'>
        <div className='flex items-center justify-center flex-col bg-white p-6 max-md:p-2 w-fit relative rounded-md gap-5'>
            { queued &&
            (<div className='flex flex-col gap-2 items-center'>
                <div className='flex items-center gap-4'>
                    <FactoryIcon style={{fontSize: 60, color: '#000000'}}>Filled</FactoryIcon>
                    <Oval
                        visible={true}
                        height="40"
                        width="40"
                        color="#52a4e0"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                        />
                </div>
                <p className='text-black font-bold text-[25px]'>Video is being transcoded, check after few moments</p>
            </div>
             ) }
            <input onChange={event => uploadStream(event.target.files[0])} type='file' ref={fileRef} hidden />
            { !loaded && !queued && 
            [<div className='flex flex-col gap-2 items-center'>
                <VideocamOffIcon style={{fontSize: 60, color: '#000000'}}>Filled</VideocamOffIcon>
                <p className='text-black font-bold text-[25px] max-md:text-sm'>No preview is found for this course. Upload here</p>
            </div>,
            <button disabled={progress != 0} onClick={() => fileRef.current.click()} className='outline-none border-none bg-main px-5 py-2 text-[22px] rounded-sm text-white max-md:text-sm'>
            {progress == 0 ? 'Upload Video' : progress == 100 ? 'Transcoding...' :  `Uploading Video ${progress?.toFixed(2)}%`}
            </button>
            ] }
            {/* {loaded == null && (
                    <div className='flex flex-col gap-3 flex-1 items-center justify-center'>
                        <p className='text-[16px]'>Loading section...</p>
                        <Oval
                            visible={true}
                            height="30"
                            width="30"
                            color="#198754"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            strokeWidth={3}
                        />
                    </div>
            )} */}
            <div style={{
                width: '80%',
                // border: '1px solid #00000070',
                borderRadius: '10px',
                overflow: 'hidden'
            }} className='max-md:!w-full'>
                {loaded && !queued && <Player options={{source}} style={{}} /> }
            </div>
             {progress == true && <p className='text-main bg-[#c0faba] px-8 py-2 text-[17px] font-bold'>Video successfully transcoded.</p>}
             <button onClick={() => setSelectedCourse(null)} className='absolute outline-none bg-white rounded-full bg-none -top-4 -right-4'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
             {loaded && <button disabled={progress != 0} onClick={() => fileRef.current.click()} className='outline-none border-none bg-main px-5 py-2 text-[18px] rounded-sm text-white mt-auto mb-4'>Re-Upload Preview</button>}
        </div>
    </div>
  )
}
